import {
  DEFAULT_OBJECTS_TAB_ID,
  selectActiveDocumentationPageTab,
} from '../../reducers/documentation/documentationPageReducer';
import { useSelector } from 'react-redux';
import { MetadataContent } from './metadata/MetadataContent';
import ObjectsView from './ObjectsView';
interface MetadataTypeWrapperProps {
  onCloseDialog?: () => void;
  crmOrgId: string;
  hideAddObjectButton?: boolean;
  isExpandedMode: boolean;
}

export const MetadataTypeWrapper = ({
  onCloseDialog,
  crmOrgId,
  hideAddObjectButton,
  isExpandedMode,
}: MetadataTypeWrapperProps) => {
  const activeTab = useSelector(selectActiveDocumentationPageTab);

  if (!activeTab) {
    return <></>;
  }

  if (activeTab === DEFAULT_OBJECTS_TAB_ID) {
    return (
      <ObjectsView
        crmOrgId={crmOrgId}
        isOpen={true}
        onCloseDialog={onCloseDialog}
        hideAddObjectButton={hideAddObjectButton}
      />
    );
  }

  return (
    <MetadataContent
      key={activeTab}
      crmOrgId={crmOrgId}
      activeTab={activeTab}
      isExpandedMode={isExpandedMode}
      onCloseDialog={onCloseDialog}
    />
  );
};
